import { graphql, useStaticQuery } from "gatsby"
import React from "react"

import HeroSmall from "@components/HeroSmall/HeroSmall"
import TableOfContents from "@components/TableOfContents/TableOfContents"
import { cn } from "@utils/utils"
import slugify from "slugify"
import DocumentationJSON from "../../data/documentation.json"
// import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter"

const DownloadSection = () => {
  const data = useStaticQuery(graphql`
    {
      hero: file(
        sourceInstanceName: { eq: "images" }
        name: { eq: "ESTP-17" }
      ) {
        ...HeroSmallFragment
      }
      peniches_archipel: file(name: { eq: "peniches_archipel" }) {
        ...Constrained
      }
    }
  `)

  const renderDocuments = (documents, level = 3) => {
    return (
      <ul className="list-disc space-y-2 pl-5">
        {Array.isArray(documents)
          ? documents.map((doc, index) => (
              <li key={index} className="mb-2">
                <a
                  target="_blank"
                  rel="noreferrer noopenner"
                  href={`${process.env.GATSBY_DOCUMENTATION_URL}/${doc.slug}`}
                  className="text-fehr-500 hover:text-fehr-600 hover:underline"
                >
                  {doc.title}{" "}
                  {doc.size && (
                    <span className="text-gray-500">({doc.size})</span>
                  )}
                </a>
              </li>
            ))
          : Object.entries(documents).map(([subSection, subDocuments]) => (
              <div key={subSection} className="mb-4">
                {React.createElement(
                  `h${level}`,
                  {
                    className: cn(
                      "mb-2 text-xl font-semibold capitalize text-black"
                    ),
                    id: slugify(subSection, {
                      lower: true,
                      remove: /[®'’()]/g,
                    }),
                  },
                  subSection.replace(/[_]/g, " ")
                )}
                {renderDocuments(subDocuments, level + 1)}
              </div>
            ))}
      </ul>
    )
  }

  return (
    <>
      <HeroSmall
        title="Téléchargements"
        backgroundHero={data.hero}
        alt={data.hero.name}
      />
      <section className="mx-auto grid max-w-7xl grid-cols-12 gap-3 p-4">
        <div className="col-span-12 ml-3 mt-3 max-lg:mr-3 lg:col-span-3">
          <TableOfContents
            lang="fr"
            img={data.peniches_archipel.childImageSharp.gatsbyImageData}
          />
        </div>

        <div className="col-span-12 space-y-16 p-7 md:col-span-9 lg:p-14">
          {Object.entries(DocumentationJSON).map(([section, documents]) => (
            <div key={section} className="mb-8">
              <h2
                id={slugify(section, { lower: true, remove: /[®'’()]/g })}
                className="mb-4 text-2xl font-bold capitalize text-black"
              >
                {section.replace(/[_]/g, " ")}
              </h2>
              {renderDocuments(documents)}
            </div>
          ))}
        </div>
      </section>
    </>
  )
}

export default DownloadSection
